import { Component, Input } from '@angular/core';
import { AboutGroups, GroupItem } from '../model/about-group';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { ActivatedRoute, Router } from '@angular/router';
import { VersionService } from '../children/version/version.service';
import { BreadcrumbService } from '@shared/components/breadcrumb/breadcrumb.service';
import { AppService } from 'app/app.service';

@Component({
    selector: 'app-about-section',
    imports: [
        CommonModule,
        BadgeModule
    ],
    templateUrl: './about-section.component.html',
    styleUrl: './about-section.component.scss'
})
export class AboutSectionComponent {

  readonly STORAGE_KEYS = {
    about: 'about.prevSelectedPeriod',
  };
  @Input() dataGroups: AboutGroups = {
    title: "",
    aboutMenuGroups: [],
  };
  versionBadgeValue: string = "0";
  faqQuestionPaths: string[] = ['general', 'flights', 'analyze', 'search', 'export', 'admin']
  theme$ = this.appService.theme$;
  
  constructor(
    private versionService: VersionService,
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private appService: AppService
  ) {
    this.versionBadgeValue = this.versionService.getAboutBadgeValue();
  }

  onCellPress(path: GroupItem["path"]) {
    const url = location.pathname;
    const breadcrumbLabel = this.route.snapshot.data['breadcrumb'] || 'About';
    this.breadcrumbService.addToBreadcrumbs(url, breadcrumbLabel);
    if (path === "version") {
      this.router.navigate(["about/version"]);
    }
    else if (path === "feedback") {
      this.router.navigate(["about/feedback"]);
    }
    else if (this.faqQuestionPaths.includes(path)) {
      this.router.navigate(["/about/faq", path]);
    }
    else if (path === "disclaimer") {
      this.router.navigate(["about/disclaimer"]);
    }
  }

  
}
